import dynamic from "next/dynamic"
import DynamicHeroWrapper from "./dynamicWrapper";

/* Add new component key to interface sectionKey customComponents/ComponentSection.tsx */
const heroes = Array.from({ length: 20 }, (_, i) => {
    const index = i === 0 ? '' : `.${i}`; 
    return {
        [`hero${i + 1}${index}`]: () => <DynamicHeroWrapper heroKey={`hero${i + 1}${index}`} />,
    };
}).reduce((acc, curr) => Object.assign(acc, curr), {});

// This will include hero1 to hero20, including the sub-heroes like hero1.1, hero1.2, ..., hero20.20

const dynamicComponents = {

    'header1': dynamic(() => import('../components/siteComponents/headers/header1'), { ssr: false }),
    'header2': dynamic(() => import('../components/siteComponents/headers/header2'), { ssr: false }),
    'header3': dynamic(() => import('../components/siteComponents/headers/header3'), { ssr: false }),
    'header4': dynamic(() => import('../components/siteComponents/headers/header4'), { ssr: false }),
    'header5': dynamic(() => import('../components/siteComponents/headers/header5'), { ssr: false }),
    'header6': dynamic(() => import('../components/siteComponents/headers/header6'), { ssr: false }),
    'header7': dynamic(() => import('../components/siteComponents/headers/header7'), { ssr: false }),
    'header8': dynamic(() => import('../components/siteComponents/headers/header8'), { ssr: false }),
    'header9': dynamic(() => import('../components/siteComponents/headers/header9'), { ssr: false }),
    'header10': dynamic(() => import('../components/siteComponents/headers/header10'), { ssr: false }),
    'header11': dynamic(() => import('../components/siteComponents/headers/header11'), { ssr: false }),
    'header13': dynamic(() => import('../components/siteComponents/headers/header13'), { ssr: false }), 
    'header12': dynamic(() => import('../components/siteComponents/headers/header12'), { ssr: false }), 
    'header14': dynamic(() => import('../components/siteComponents/headers/header14'), { ssr: false }), 
    'header15': dynamic(() => import('../components/siteComponents/headers/header15'), { ssr: false }), 


    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`infoheader1${index}`]: () => <DynamicHeroWrapper heroKey={`infoheader1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
   

    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`banner1${index}`]: () => <DynamicHeroWrapper heroKey={`banner1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`banner2${index}`]: () => <DynamicHeroWrapper heroKey={`banner2${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`banner3${index}`]: () => <DynamicHeroWrapper heroKey={`banner3${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`banner4${index}`]: () => <DynamicHeroWrapper heroKey={`banner4${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`banner5${index}`]: () => <DynamicHeroWrapper heroKey={`banner5${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`banner6${index}`]: () => <DynamicHeroWrapper heroKey={`banner6${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`banner7${index}`]: () => <DynamicHeroWrapper heroKey={`banner7${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`banner8${index}`]: () => <DynamicHeroWrapper heroKey={`banner8${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
     ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`banner9${index}`]: () => <DynamicHeroWrapper heroKey={`banner9${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),

    ...Array.from({length : 20}, (_, i) => {
        const index = i === 0 ? '' : `.${i}`;
        return{
            [`carousel1${index}`] : () => <DynamicHeroWrapper heroKey={`carousel1${index}`}/>,
        }
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),

    'carousel2': dynamic(() => import('../components/siteComponents/banners/carousel2'), { ssr: false }),

    'programs3': dynamic(() => import('../components/siteComponents/programs/programs3'), { ssr: false }), 
    'programs4': dynamic(() => import('../components/siteComponents/categories/programs4'), { ssr: false }),

    'category3': dynamic(() => import('../components/siteComponents/categories/category3'), { ssr: false }),
    'category4': dynamic(() => import('../components/siteComponents/categories/category4'), { ssr: false }),
    'category5': dynamic(() => import('../components/siteComponents/categories/category5'), { ssr: false }),
    'category6': dynamic(() => import('../components/siteComponents/categories/category6'), { ssr: false }),
    'category7': dynamic(() => import('../components/siteComponents/categories/Category7'), { ssr: false }),





    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`tamkeenHeader${index}`]: () => <DynamicHeroWrapper heroKey={`tamkeenHeader${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`tamkeenFooter${index}`]: () => <DynamicHeroWrapper heroKey={`tamkeenFooter${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`hero1${index}`]: () => <DynamicHeroWrapper heroKey={`hero1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
     ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`heroLayout${index}`]: () => <DynamicHeroWrapper heroKey={`heroLayout${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
      ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`heroLayout1${index}`]: () => <DynamicHeroWrapper heroKey={`heroLayout1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`hero2${index}`]: () => <DynamicHeroWrapper heroKey={`hero2${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
     ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`hero3${index}`]: () => <DynamicHeroWrapper heroKey={`hero3${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`hero4${index}`]: () => <DynamicHeroWrapper heroKey={`hero4${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`hero5${index}`]: () => <DynamicHeroWrapper heroKey={`hero5${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`hero6${index}`]: () => <DynamicHeroWrapper heroKey={`hero6${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`hero7${index}`]: () => <DynamicHeroWrapper heroKey={`hero7${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`hero8${index}`]: () => <DynamicHeroWrapper heroKey={`hero8${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`hero9${index}`]: () => <DynamicHeroWrapper heroKey={`hero9${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`hero10${index}`]: () => <DynamicHeroWrapper heroKey={`hero10${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`hero11${index}`]: () => <DynamicHeroWrapper heroKey={`hero11${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`contact1${index}`]: () => <DynamicHeroWrapper heroKey={`contact1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`contact2${index}`]: () => <DynamicHeroWrapper heroKey={`contact2${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),


    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`about1${index}`]: () => <DynamicHeroWrapper heroKey={`about1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`about2${index}`]: () => <DynamicHeroWrapper heroKey={`about2${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),

    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`ticker1${index}`]: () => <DynamicHeroWrapper heroKey={`ticker1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`layoutGrid${index}`]: () => <DynamicHeroWrapper heroKey={`layoutGrid${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`LayoutFooter${index}`]: () => <DynamicHeroWrapper heroKey={`layoutFooter${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`layoutFooter2${index}`]: () => <DynamicHeroWrapper heroKey={`layoutFooter2${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`footerInfo2${index}`]: () => <DynamicHeroWrapper heroKey={`footerInfo2${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`layoutFooter1${index}`]: () => <DynamicHeroWrapper heroKey={`layoutFooter1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),

    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`layout1${index}`]: () => <DynamicHeroWrapper heroKey={`layout1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`layout2${index}`]: () => <DynamicHeroWrapper heroKey={`layout2${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`layout3${index}`]: () => <DynamicHeroWrapper heroKey={`layout3${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
       ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`layout4${index}`]: () => <DynamicHeroWrapper heroKey={`layout4${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),   ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`layout5${index}`]: () => <DynamicHeroWrapper heroKey={`layout5${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),   ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`layout6${index}`]: () => <DynamicHeroWrapper heroKey={`layout6${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}), 
     ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`layout7${index}`]: () => <DynamicHeroWrapper heroKey={`layout7${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
      ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`layout8${index}`]: () => <DynamicHeroWrapper heroKey={`layout8${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
      ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`layout9${index}`]: () => <DynamicHeroWrapper heroKey={`layout9${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`columnLayout${index}`]: () => <DynamicHeroWrapper heroKey={`columnLayout${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`cardLayout${index}`]: () => <DynamicHeroWrapper heroKey={`cardLayout${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`cardRowLayout1${index}`]: () => <DynamicHeroWrapper heroKey={`cardRowLayout1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`rowLayout${index}`]: () => <DynamicHeroWrapper heroKey={`rowLayout${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`cardRowLayout${index}`]: () => <DynamicHeroWrapper heroKey={`cardRowLayout${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`servicesBlock1${index}`]: () => <DynamicHeroWrapper heroKey={`servicesBlock1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`versatileBlock1${index}`]: () => <DynamicHeroWrapper heroKey={`versatileBlock1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),
    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`teamGridBlock1${index}`]: () => <DynamicHeroWrapper heroKey={`teamGridBlock1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),

    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`;
        return {
            [`teamCategoryBlock1${index}`]: () => <DynamicHeroWrapper heroKey={`teamCategoryBlock1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),

    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`;
        return {
            [`flexibleContentBlock1${index}`]: () => <DynamicHeroWrapper heroKey={`flexibleContentBlock1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),

    'feature1': dynamic(() => import('../components/siteComponents/features/feature1'), { ssr: false }),
    'feature2': dynamic(() => import('../components/siteComponents/features/feature2'), { ssr: false }),
    'feature3': dynamic(() => import('../components/siteComponents/features/feature3'), { ssr: false }),
    'feature4': dynamic(() => import('../components/siteComponents/features/feature4'), { ssr: false }),

    'footer2': dynamic(() => import('../components/siteComponents/footer/footer2'), { ssr: false }),
    'footer3': dynamic(() => import('../components/siteComponents/footer/footer3'), { ssr: false }),
    'footer4': dynamic(() => import('../components/siteComponents/footer/footer4'), { ssr: false }),
    'footer5': dynamic(() => import('../components/siteComponents/footer/footer5'), { ssr: false }),
    'footer6': dynamic(() => import('../components/siteComponents/footer/footer6'), { ssr: false }),
    'footer7': dynamic(() => import('../components/siteComponents/footer/footer7'), { ssr: false }),
    'footer8': dynamic(() => import('../components/siteComponents/footer/footer8'), { ssr: false }),
    'footer9': dynamic(() => import('../components/siteComponents/footer/footer9'), { ssr: false }),
    'footer10': dynamic(() => import('../components/siteComponents/footer/footer10'), { ssr: false }),
    'footer13': dynamic(() => import('../components/siteComponents/footer/footer13'), { ssr: false }),
    'footer14': dynamic(() => import('../components/siteComponents/footer/footer14'), { ssr: false }),
    'footer15': dynamic(() => import('../components/siteComponents/footer/footer15'), { ssr: false }),
    'footer16': dynamic(() => import('../components/siteComponents/footer/footer16'), { ssr: false }),
    'footer17': dynamic(() => import('../components/siteComponents/footer/footer17'), { ssr: false }),
    'footer18': dynamic(() => import('../components/siteComponents/footer/footer18'), { ssr: false }),


    'footerInfo1': dynamic(() => import('../components/siteComponents/footerInfo/footerInfo'), { ssr: false }),

    
    
    'list1': dynamic(() => import('../components/siteComponents/list/list1'), { ssr: false }),
    'list2': dynamic(() => import('../components/siteComponents/list/list2'), { ssr: false }),
    'list3': dynamic(() => import('../components/siteComponents/list/list3'), { ssr: false }),


    'team1': dynamic(() => import('../components/siteComponents/team/team1'), { ssr: false }),
    'team2': dynamic(() => import('../components/siteComponents/team/team2'), { ssr: false }),

    'statistic1': dynamic(() => import('../components/siteComponents/statistic/statistic1'), { ssr: false }),
    'statistic2': dynamic(() => import('../components/siteComponents/statistic/statistic2'), { ssr: false }),
    'statistic3': dynamic(() => import('../components/siteComponents/statistic/statistic3'), { ssr: false }),

    'testimonial1': dynamic(() => import('../components/siteComponents/testimonial/testimonial1'), { ssr: false }),
    'testimonial2': dynamic(() => import('../components/siteComponents/testimonial/testimonial2'), { ssr: false }),
    'testimonial3': dynamic(() => import('../components/siteComponents/testimonial/testimonial3'), { ssr: false }),
    'testimonial4': dynamic(() => import('../components/siteComponents/testimonial/testimonail4'), { ssr: false }),
   
    'cta1': dynamic(() => import('../components/siteComponents/cta/cta1'), { ssr: false }),

    'promotion1': dynamic(() => import('../components/siteComponents/promotions/promotion1'), { ssr: false }),
    'promotion2': dynamic(() => import('../components/siteComponents/promotions/promotion2'), { ssr: false }),

    'content1': dynamic(() => import('../components/siteComponents/content/content1'), { ssr: false }),
    'content3': dynamic(() => import('../components/siteComponents/content/content3'), { ssr: false }),
  
   

    // 'youtube1': dynamic(() => import('../components/siteComponents/youtube/youtube1'), { ssr: false }),

    ...Array.from({ length: 20 }, (_, i) => {
        const index = i === 0 ? '' : `.${i}`; 
        return {
            [`youtube1${index}`]: () => <DynamicHeroWrapper heroKey={`youtube1${index}`} />,
        };
    }).reduce((acc, curr) => Object.assign(acc, curr), {}),


    'youtube2': dynamic(() => import('../components/siteComponents/youtube/youtube2'), { ssr: false }),
    'youtube3': dynamic(() => import('../components/siteComponents/youtube/youtube3'), { ssr: false }),

    'programs1': dynamic(() => import('../components/siteComponents/programs/programs1'), { ssr: false }),
    'programs2': dynamic(() => import('../components/siteComponents/programs/programs2'), { ssr: false }),
    
    
        
    'tab1': dynamic(() => import('../components/siteComponents/tabs/tabs1'), { ssr: false }),
    
    'categoryPrograms1': dynamic(() => import('../components/siteComponents/categoryPrograms/categoryPrograms1'), { ssr: false }),
    'categoryPrograms3': dynamic(() => import('../components/siteComponents/categoryPrograms/categoryPrograms3'), { ssr: false }),
    'programGridCard': dynamic(() => import('../components/siteComponents/categoryPrograms/programGridCard'), { ssr: false }),


    'articles1': dynamic(() => import('../components/siteComponents/articles/articles1'), { ssr: false }),
    'articles2': dynamic(() => import('../components/siteComponents/articles/articles2'), { ssr: false }),

    'achievers1': dynamic(() => import('../components/siteComponents/achievers/achievers1'), { ssr: false }),

    

    // 'statistics1': dynamic(() => import('../components/siteComponents/statistics/statistics1'), { ssr: false })

};

export {
    dynamicComponents
}

// export default dynamicComponents;